export default abstract class HasProperties {
    constructor(data: { tabs: any[] }|{ [key: string]: any }) {
        this.setProperties(data);
    }

    protected setProperties(data: { tabs: any[] }|{ [key: string]: any }) {
        let parsed = Object.entries(data).map((entry: any[]) => {
            return [entry[0], (this.castsWithDefaults[entry[0]] || ((e: any) => e))(entry[1])];
        });

        Object.assign(this, Object.fromEntries(parsed));
    }

    public get casts(): any {
        return {
            created_at: (created_at: any) => new Date(created_at),
            updated_at: (updated_at: any) => new Date(updated_at),
        };
    }

    private get castsWithDefaults(): any {
        return Object.assign({
            created_at: (created_at: any) => new Date(created_at),
            updated_at: (updated_at: any) => new Date(updated_at),
        }, this.casts);
    }
}